import { brandToast, transactionToast } from "@/components/brand/BrandToast";

/**
 * useToast Hook
 *
 * Convenience hook for using branded toast notifications
 * throughout the application.
 *
 * @example
 * ```tsx
 * const { success, error, warning, info } = useToast();
 *
 * success('Operation completed!');
 * error('Something went wrong', { description: 'Please try again' });
 * warning('Check your input');
 * info('New update available');
 *
 * // Show loading message
 * const loadingId = loading('Processing...');
 * dismiss(loadingId);
 * success('Done!');
 *
 * // Transaction-specific toasts
 * transaction.pending('Transaction submitted', {
 *   txHash: '0x123...',
 *   explorerUrl: 'https://solscan.io/tx/0x123...'
 * });
 * ```
 */
export function useToast() {
  return {
    // Standard toasts
    success: brandToast.success,
    error: brandToast.error,
    warning: brandToast.warning,
    info: brandToast.info,
    loading: brandToast.loading,
    promise: brandToast.promise,
    custom: brandToast.custom,

    // Transaction-specific toasts
    transaction: transactionToast,

    // Dismiss functions
    dismiss: brandToast.dismiss,
    dismissAll: brandToast.dismissAll,
  };
}

/**
 * Re-export toast functions for direct import
 */
export { brandToast as toast, transactionToast };
